import React, { useEffect, useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import styled from "styled-components";
import { motion, AnimatePresence } from "framer-motion";
import { ACADEMY_PROGRAMS } from "../context/ProgramData";

const ProgramDetail = () => {
  const { id } = useParams();
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);
  const data = ACADEMY_PROGRAMS[id];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    document.title = "Program - ERA AESTHETICS";
  }, []);

  if (!data)
    return (
      <div style={{ padding: "100px", textAlign: "center" }}>
        Programm nicht gefunden
      </div>
    );

  const openBooking = (url) => {
    window.open(url, "_blank");
    setIsBookingModalOpen(false);
  };

  return (
    <PageWrapper
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <Content>
        <TextSide>
          <BackLink to="/academy">← Zurück zur Akademie</BackLink>
          <Label>Professionelle Ausbildung</Label>
          <Title>{data.title}</Title>
          <Description>
            {data.desc.intro.map((text, i) => (
              <p key={i}>{text}</p>
            ))}

            <h4>Inhalte der 1:1 Schulung:</h4>

            <ul>
              {data.desc.bullets.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>

            {data.desc.extras.map((text, i) => (
              <p key={i}>{text}</p>
            ))}
          </Description>

          <MetaGrid>
            <MetaItem>
              <span>Preis</span>
              <p>{data.price}</p>
            </MetaItem>
          </MetaGrid>

          {/* Trigger Modal instead of direct link */}
          <EnrollBtn onClick={() => setIsBookingModalOpen(true)}>
            Jetzt Anmelden
          </EnrollBtn>
        </TextSide>

        <ImageSide>
          <img src={data.img} alt={data.title} />
        </ImageSide>
      </Content>

      {/* --- BOOKING SELECTION MODAL --- */}
      <AnimatePresence>
        {isBookingModalOpen && (
          <ModalOverlay
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setIsBookingModalOpen(false)}
          >
            <ModalContent
              initial={{ scale: 0.9, opacity: 0, y: 20 }}
              animate={{ scale: 1, opacity: 1, y: 0 }}
              exit={{ scale: 0.9, opacity: 0, y: 20 }}
              onClick={(e) => e.stopPropagation()}
            >
              <CloseBtn onClick={() => setIsBookingModalOpen(false)}>
                &times;
              </CloseBtn>
              <h3>Anmeldung</h3>
              <p>
                Wählen Sie Ihre bevorzugte Buchungsplattform für dieses
                Programm:
              </p>

              <ButtonGroup>
                <PlatformBtn
                  onClick={() =>
                    openBooking(
                      "https://buchung.treatwell.de/ort/era-aesthetics-academy/",
                    )
                  }
                >
                  <span>Treatwell</span>
                  <small>Schnelle Online-Buchung</small>
                </PlatformBtn>

                <PlatformBtn
                  onClick={() =>
                    openBooking(
                      "https://beautinda.de/artist/glAjRxw9FkUTkPh98ZNpnvDTdqV2",
                    )
                  }
                >
                  <span>Beautinda</span>
                  <small>Alternative Buchung</small>
                </PlatformBtn>
              </ButtonGroup>
            </ModalContent>
          </ModalOverlay>
        )}
      </AnimatePresence>
    </PageWrapper>
  );
};

export default ProgramDetail;

// --- Styled Components (Modal Specific) ---

const ModalOverlay = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(90, 82, 72, 0.6);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  padding: 20px;
`;

const ModalContent = styled(motion.div)`
  background: #fdfcfb;
  padding: 3rem;
  border-radius: 30px;
  max-width: 450px;
  width: 100%;
  text-align: center;
  position: relative;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);
  h3 {
    font-family: "Playfair Display", serif;
    font-size: 2rem;
    color: #5a5248;
    margin-bottom: 1rem;
  }
  p {
    color: #6d6357;
    margin-bottom: 2rem;
    font-size: 0.9rem;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const PlatformBtn = styled.button`
  background: white;
  border: 1px solid rgba(109, 99, 87, 0.2);
  padding: 18px;
  border-radius: 15px;
  cursor: pointer;
  transition: all 0.3s ease;
  span {
    display: block;
    font-size: 1.1rem;
    font-weight: 600;
    color: #5a5248;
  }
  small {
    color: #857869;
    font-size: 0.7rem;
    text-transform: uppercase;
    letter-spacing: 0.05rem;
  }
  &:hover {
    background: #6d6357;
    span,
    small {
      color: white;
    }
  }
`;

const CloseBtn = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  background: none;
  border: none;
  font-size: 2rem;
  color: #5a5248;
  cursor: pointer;
  opacity: 0.5;
  &:hover {
    opacity: 1;
  }
`;

const MAIN_COLOR = "#5a5248";

// --- Original Styled Components ---
const PageWrapper = styled(motion.div)`
  min-height: 100vh;
  background: #f9f8f6;
  color: ${MAIN_COLOR};
  display: flex;
  align-items: center;
  padding: 120px 5% 60px; /* Increased top padding for fixed navbars */

  @media (max-width: 768px) {
    padding: 100px 20px 40px;
    align-items: flex-start;
  }
`;

const Content = styled.div`
  display: grid;
  grid-template-columns: 1fr 1.2fr;
  gap: 80px;
  width: 100%;
  max-width: 1700px;
  margin: 0 auto;

  @media (max-width: 1100px) {
    gap: 40px;
  }

  @media (max-width: 968px) {
    grid-template-columns: 1fr;
    /* Reversing order so image stays near the top or specific logic */
    display: flex;
    flex-direction: column-reverse;
    gap: 40px;
  }
`;

const TextSide = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media (max-width: 968px) {
    text-align: center;
    align-items: center;
  }
`;

const BackLink = styled(Link)`
  text-decoration: none;
  color: ${MAIN_COLOR};
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.1rem;
  margin-bottom: 2rem;
  opacity: 0.5;
  transition: opacity 0.3s ease;

  &:hover {
    opacity: 1;
  }

  @media (max-width: 968px) {
    align-self: flex-start; /* Keeps back button left-aligned if desired */
    margin-bottom: 1.5rem;
  }
`;

const Label = styled.span`
  text-transform: uppercase;
  letter-spacing: 0.3rem;
  font-size: 0.7rem;
  opacity: 0.6;
`;

const Title = styled.h1`
  font-family: "Playfair Display", serif;
  font-size: clamp(2rem, 8vw, 4rem);
  margin: 1rem 0 1.5rem 0;
  font-weight: 400;
  line-height: 1.2;
`;

const Description = styled.div`
  font-size: 0.95rem;
  line-height: 1.2;
  opacity: 0.85;
  margin-bottom: 1.5rem;

  p {
    margin-bottom: 1.4rem;
  }

  h4 {
    margin: 2rem 0 1.2rem;
    font-weight: 600;
    letter-spacing: 0.03em;
  }

  ul {
    margin: 0 0 2.5rem 1.2rem;
    padding-left: 1rem;
  }

  li {
    margin-bottom: 0.7rem;
  }
`;

const MetaGrid = styled.div`
  display: flex;
  gap: 4rem;
  margin-bottom: 3rem;
  border-top: 1px solid rgba(90, 82, 72, 0.1);
  padding-top: 2rem;
  width: 100%;

  @media (max-width: 968px) {
    justify-content: center;
    gap: 2rem;
  }
`;

const MetaItem = styled.div`
  span {
    font-size: 0.7rem;
    text-transform: uppercase;
    opacity: 0.5;
    letter-spacing: 0.1rem;
  }
  p {
    font-size: 1.5rem;
    font-family: "Playfair Display", serif;
    margin-top: 0.5rem;
  }
`;

const EnrollBtn = styled.button`
  background: ${MAIN_COLOR};
  color: white;
  border: none;
  padding: 18px 40px;
  width: fit-content;
  text-transform: uppercase;
  letter-spacing: 0.2rem;
  font-size: 0.8rem;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  }

  @media (max-width: 968px) {
    width: 100%; /* Full width button on mobile for better UX */
    max-width: 400px;
  }
`;

const ImageSide = styled.div`
  height: 70vh;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.05);

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media (max-width: 968px) {
    height: 45vh; /* Shorter image on mobile to save scroll space */
    width: 100%;
  }

  @media (max-width: 480px) {
    height: 35vh;
  }
`;
